import { SurveyDetail as SurveyDetailComponent } from './SurveyDetail.component';
import { connector } from './SurveyDetail.connector';

export const SurveyDetail = connector(SurveyDetailComponent);
